import { render, staticRenderFns } from "./passAdd.vue?vue&type=template&id=ee754d92&scoped=true&"
import script from "./passAdd.vue?vue&type=script&lang=js&"
export * from "./passAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee754d92",
  null
  
)

export default component.exports